/**
 * @generated SignedSource<<40493892b81ea047cdc85614c3db843e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type headPlusNewsAgendaRightHeadTopic$data = {
  readonly name: string;
  readonly newsAgenda: {
    readonly secondaryDescription: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"hooksNewsAgendaTopic">;
  readonly " $fragmentType": "headPlusNewsAgendaRightHeadTopic";
};
export type headPlusNewsAgendaRightHeadTopic$key = {
  readonly " $data"?: headPlusNewsAgendaRightHeadTopic$data;
  readonly " $fragmentSpreads": FragmentRefs<"headPlusNewsAgendaRightHeadTopic">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "headPlusNewsAgendaRightHeadTopic",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NewsAgenda",
      "kind": "LinkedField",
      "name": "newsAgenda",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "secondaryDescription",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "hooksNewsAgendaTopic"
    }
  ],
  "type": "Topic",
  "abstractKey": null
};

(node as any).hash = "ad291a5bcdda84be66f78a10b338de9c";

export default node;
